module.exports = __webpack_public_path__ + "media/svg/app-store-4c2ea683.svg";